import { sankey, sankeyLinkHorizontal } from "d3-sankey";
import { select } from "d3";
import { ColorLookup } from "./CTSAReportHelper";

const colors = { ...ColorLookup, 'R01': "#a25acd", 'R': "#d49d37", 'K': "#c0704d", 'other': "#cd4fa6" }
const getTooltip = (d) => {
    let value;
    if (d.value < 5) {
        value = 'person count<5';
    } else {
        value = `person count: ${d.value}`;
    }
    return `${d.source.name} → ${d.target.name}\n${value}`;
}
export function renderSankey(container, sankeyData, { width, height, duration }, comparisonGroup) {
    const sankeyGenerator = sankey()
        .nodeId(d => d.id)
        .size([width, height])
        .nodeWidth(15)
        .nodePadding(20)
        .extent([[1, 1], [width - 1, height - 5]])
        .nodeSort(null);

    const { nodes, links } = sankeyGenerator({
        nodes: sankeyData.nodes.map(d => ({ ...d })),
        links: sankeyData.links.map(d => ({ ...d }))
    });

    select(container).append("g").attr('class', "links");
    select(container).append("g").attr('class', "texts");

    //nodes
    const nodesUpdate = select(container)
        .selectAll("rect")
        .data(nodes, d => d.name);

    nodesUpdate.exit().remove();

    const nodesEnter = nodesUpdate
        .enter()
        .append("rect")
        .attr("stroke", "#000")
        .attr("x", d => d.x0)
        .attr("y", d => d.y0)
        .attr("height", d => d.y1 - d.y0)
        .attr("width", d => d.x1 - d.x0)
        .attr("fill", d => {
            if (d.name.includes("n")) {
                    return colors[d.name.replace(/\s\(n=\d+\)/g, '')];
            } else {
                return colors[d.name];
            }
        }
        )
        .append("title")
        .text(d => `${d.name}: ${d.value}`);

    //transition
    const nodesMerge = nodesUpdate.merge(nodesEnter);

    nodesMerge.transition().duration(duration)
        .attr("stroke", "#000")
        .attr("x", d => d.x0)
        .attr("y", d => d.y0)
        .attr("height", d => d.y1 - d.y0)
        .attr("width", d => d.x1 - d.x0)
        .attr("fill", d => {
            if (d.name.includes("n")) {
                return colors[d.name.replace(/\s\(n=\d+\)/g, '')];
            } else {
                return colors[d.name];
            }
        });
       

    const linksUpdate = select("g.links")
        .selectAll("g")
        .data(links, d => `${d.source.name}-${d.target.name}`);
    linksUpdate.exit().remove();
    const linksEnter = linksUpdate.enter().append("g");
    linksEnter.append("path");

    linksEnter.append("title");

    const linksMerge = linksUpdate.merge(linksEnter).transition().duration(duration)

    linksMerge.select("path")
        .attr("d", sankeyLinkHorizontal())
        .attr("stroke", d => colors[d.target.name])
        .attr("stroke-width", d => d.width)
        .attr("fill", "none")
        .attr("stroke-opacity", 0.5)
    linksMerge.select("title").text(d => {
        return getTooltip(d)
    });

    const textsUpdate = select('g.texts').selectAll("text").data(nodes);
    textsUpdate.exit().remove();
    textsUpdate.enter().append("text")
        .merge(textsUpdate)
        .attr("x", d => d.x0 < width / 2 ? d.x1 + 6 : d.x0 - 6)
        .attr("y", d => (d.y1 + d.y0) / 2)
        .attr("style", "font-size: 16px")
        .attr("dy", "0.35em")
        .attr("text-anchor", d => d.x0 < width / 2 ? "start" : "end")
        .attr("visibility", d => ['KL2',...comparisonGroup].includes(d.name) && "hidden")
        .text(d => d.name);              
}



